<template>
	<div class="index">
		<portal to="title">Invoices</portal>
		<portal to="actions">
			<div class="row">
				<div
					class="offset-md-6 col-md-6 offset-sm-0 col-sm-12 mb-4 d-flex justify-content-lg-end justify-content-sm-between"
					v-if="(paginator && paginator.data && paginator.data.length) || paginatorOptions.search.length"
				>
					<vue-search-input
						placeholder="Search invoices"
						v-on:search="
							paginatorOptions.search = $event;
							paginatorOptions.page = 1;
						"
						:loading="loading"
					/>
				</div>
			</div>
		</portal>

		<vue-table
			:paginator="paginator"
			:rows="3"
			:columns="3"
			:loading="loading"
			v-on:retrieve-page="paginatorOptions.page = $event"
		>
			<template v-slot:card="data">
				<h6 class="card-header-invoice" :class="data.item | invoiceStatusClass">
					{{ data.item.number }}
				</h6>

				<div class="card-body px-4 pt-4">
					<p class="text-muted my-2">
						Therapist(s): <span class="text-blue-dark pl-1">{{ data.item.therapists }}</span>
					</p>
					<p class="text-muted my-2">
						Patient(s): <span class="text-blue-dark pl-1">{{ data.item.patients }}</span>
					</p>
					<p class="text-muted my-2">
						Due Date: <span class="text-blue-dark pl-1">{{ data.item.due_date | timeFormat }}</span>
					</p>
					<p class="text-muted my-2">
						Status: <span class="text-blue-dark pl-1">{{ data.item | invoiceStatusText }}</span>
					</p>
					<p class="text-muted my-2">
						Total cost (excl. travel): <span class="text-blue-dark pl-1">£{{ data.item.amount }}</span>
					</p>
				</div>

				<div class="card-footer text-muted bg-white border-0 pb-4 rounded-lg px-4">
					<hr class="mb-4 mt-0" />

					<div class="d-flex align-items-center">
						<router-link :to="`/invoices/${data.item.id}`" class="initialism text-muted">
							View Details

							<i class="fa fa-chevron-right ml-2 hvr-icon"></i>
						</router-link>
					</div>
				</div>
			</template>
		</vue-table>
	</div>
</template>

<script>
	import Vue from 'vue';
	import moment from 'moment';

	import VueTable from '@components/table';
	import VueSearchInput from '@components/searchInput';

	import invoicesService from '@api/invoices';

	export default Vue.extend({
		components: {
			VueTable,
			VueSearchInput
		},
		data() {
			return {
				paginator: {},
				paginatorOptions: {
					page: this.$route.query.page || 1,
					search: this.$route.query.search || ''
				},
				loading: true
			};
		},
		filters: {
			timeFormat(value) {
				return moment(value).format('Do MMM YYYY \\a\\t HH:mm');
			},
			invoiceStatusText(invoice) {
				switch (invoice.status) {
					case 'paid':
						return 'Paid';
					case 'unpaid':
						return 'Unpaid';
					case 'canceled':
						return 'Canceled';
					default:
						return 'Unknown';
				}
			},
			invoiceStatusClass(invoice) {
				switch (invoice.status) {
					case 'paid':
						return 'card-header-accepted';
					case 'unpaid':
						return 'card-header-rejected';
					case 'canceled':
						return 'card-header-pending';
					default:
						return 'card-header-unknown';
				}
			}
		},
		watch: {
			paginatorOptions: {
				deep: true,
				handler() {
					this.fetch();
				}
			}
		},
		methods: {
			fetch() {
				this.loading = true;

				invoicesService
					.index(this.paginatorOptions)
					.then(response => {
						this.paginator = response.data;
					})
					.catch(error => {
						window.location.href = `/error/${error.response.status}`;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		mounted() {
			this.fetch();
		}
	});
</script>
